/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the String length of a given `key` is invalid
 * @export
 * @class I18nInvalidKeyLengthError
 * @extends {Error}
 */
export class I18nInvalidKeyLengthError extends Error {
  /**
   * Creates an instance of I18nInvalidKeyLengthError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidKeyLengthError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidKeyLengthError`;
  }
}

/**
 * Called when the String length of a given `key` is invalid
 * @param {string} key The invalid `key`
 * @returns {never} never
 */
const throwI18nInvalidKeyLengthError = (key) => {
  throw new I18nInvalidKeyLengthError(
    stripIndent(`
    Expected "key" to have a "length" greater than "0";
    Got: "${key}"
    `),
  );
};

export default throwI18nInvalidKeyLengthError;
